import { injectStyle } from "./../../../../utils/style";
import { h } from "./../../../../utils/createElement";
import { __extends } from "tslib";
import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import DateConstants from './DateConstants';
import dayjs from '../dayjs';
injectStyle("components/DateTimePicker/rc-calendar/style/common/DateTHead.css", "[data-duim-0-106-4~=\"dui-m-calendar-thead\"]{width:100%}[data-duim-0-106-4~=\"dui-m-calendar-thead-row\"]{display:-webkit-box;display:-webkit-flex;display:flex;width:100%}[data-duim-0-106-4~=\"dui-m-calendar-column-header\"]{-webkit-box-flex:1;-webkit-flex:1;flex:1;padding:4px 0;line-height:40px;text-align:center}[data-duim-0-106-4~=\"dui-m-calendar-column-header-inner\"]{font-size:16px;display:block;color:var(--text-medium,rgba(0,0,0,.4))}[data-duim-0-106-4~=\"dui-m-calendar-week-number-header\"] [data-duim-0-106-4~=\"dui-m-calendar-column-header-inner\"]{display:none}");
var DateTHead = (function (_super) {
    __extends(DateTHead, _super);
    function DateTHead() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DateTHead.prototype.render = function () {
        var _a = this.props, value = _a.value, prefixCls = _a.prefixCls, showWeekNumber = _a.showWeekNumber;
        var localeData = value.localeData();
        var veryShortWeekdays = [];
        var weekDays = [];
        var firstDayOfWeek = localeData.firstDayOfWeek();
        var now = dayjs();
        Array.from({ length: DateConstants.DATE_COL_COUNT }).forEach(function (_, dateColIndex) {
            var index = (firstDayOfWeek + dateColIndex) % DateConstants.DATE_COL_COUNT;
            var day = now.day(index);
            veryShortWeekdays.push(localeData.weekdaysMin(day));
            weekDays.push(localeData.weekdaysShort(day));
        });
        var weekNumberEl = showWeekNumber ? (h("div", { className: prefixCls + "-column-header " + prefixCls + "-week-number-header", role: "columnheader" },
            h("span", { className: prefixCls + "-column-header-inner" }, "x"))) : null;
        var weekDaysEls = weekDays.map(function (day, index) { return (h("div", { key: day, className: prefixCls + "-column-header", role: "columnheader", title: day },
            h("span", { className: prefixCls + "-column-header-inner" }, veryShortWeekdays[index]))); });
        return (h("div", { className: prefixCls + "-thead" },
            h("div", { className: prefixCls + "-thead-row" },
                weekNumberEl,
                weekDaysEls)));
    };
    return DateTHead;
}(PureComponent));
DateTHead.propTypes = {
    prefixCls: PropTypes.string,
    showWeekNumber: PropTypes.bool,
    value: PropTypes.instanceOf(dayjs),
};
DateTHead.defaultProps = {
    prefixCls: 'dui-m-calendar',
    showWeekNumber: false,
    value: undefined,
};
export default DateTHead;
